// Components
// Hooks
import useTranslation from '@/utils/hooks/translation/useTranslation';

import Icon from '@/components/base/Icon';

export const NoPostsFound = () => {
    const { t } = useTranslation('giveaway_picker');
    return (
        <div
            className="flex h-56 flex-col items-center justify-center text-center"
            data-testid="no-posts-found">
            <span className="mb-6 flex shrink-0 grow-0 items-center justify-center rounded-full bg-icoBlue-100 p-4 text-icoBlue">
                <Icon icon="content" className="h-4 w-4" />
            </span>
            <p className="text-lg font-bold">{t('post_selection.no_posts_found')}</p>
            <p className="text-sm text-gray-500">{t('post_selection.try_different_account')}</p>
        </div>
    );
};
